import styled, { DefaultTheme } from "styled-components";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

interface IStyles {
    theme: DefaultTheme;
    imageId?: string;
}

const IMAGE_CONTAINER_HEIGHT = 252;
const IMAGE_CONTAINER_HEIGHT_SNACCV2 = 385;

export const TextContainer = styled.div<IStyles>(({ theme, imageId }) => ({
    display: "flex",
    margin: imageId
        ? `${theme.spacing.large} ${theme.spacing.xLarge} 0 ${theme.spacing.xLarge}`
        : `calc(${theme.spacing.small} * 5) ${theme.spacing.xLarge} 0 ${theme.spacing.xLarge}`,
}));

export const ImageContainer = styled.div<{ isSnaccStorefrontV2?: boolean }>(({ isSnaccStorefrontV2 = false }) => ({
    width: "100%",
    height: isSnaccStorefrontV2 ? `${IMAGE_CONTAINER_HEIGHT_SNACCV2}px` : `${IMAGE_CONTAINER_HEIGHT}px`,
    overflow: "hidden",
}));

export const StyledImage = styled(Image)<{ isSnaccStorefrontV2?: boolean }>(({ isSnaccStorefrontV2 = false }) => {
    return {
        ...(isSnaccStorefrontV2 && {
            transform: "scale(1.6)",
            "transform-origin": "center",
        }),
    };
});

export const IconContainer = styled.span`
    margin-top: 3px;
`;

export const Name = styled(Text)(({ theme }) => {
    return {
        marginLeft: `${theme.spacing.xSmall}`,
    };
});

export const TextInternal = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const Description = styled(Text)(({ theme }) => {
    return {
        margin: `${theme.spacing.xSmall} ${theme.spacing.xLarge} calc(var(--sab, 4px) + ${theme.spacing.xLarge}) ${theme.spacing.xLarge}`,
    };
});

export const BasePriceContainer = styled(Text)`
    text-decoration: line-through;
    text-decoration-line: line-through;

    margin-right: ${(props) => props.theme.spacing.xxSmall};
`;

export const FlexContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;
